import React from 'react';
import styled from 'styled-components';
import {StyledSelect2Bordered} from '@styled';

const PaginationWrapper = styled.div`
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    .page-size {
      margin-top: 10px;
    }
  }
`;

const PageButton = styled.div`
  display: inline-flex;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
  opacity: 0.7;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover,
  :focus {
    opacity: 0.2;
    border: 1px solid #000000;
    box-sizing: border-box;
    border-radius: 5px;
  }
  :active,
  &.active {
    background: #ffffff;
    box-shadow: 0px 1px 3px rgba(38, 38, 65, 0.1);
    border-radius: 5px;
    font-weight: 600;
    opacity: 1;
  }
`;

const pageSizes = [10, 20, 30, 40, 50].map((item) => ({
  value: item,
  label: `Show ${item} records`,
}));

const Pagination = ({page, pageCount, pageSize, gotoPage, setPageSize}) => {
  // display 10 numbers
  // example 1,2,3,4,5,6,7,8, ..., 23
  // example 8,...,9,10,11,12,13,14,16, ... , 23
  // example 16,..., 17,18,19,20 ,21,22,23
  // each time show 10 pages button
  // more then meaning put ... click on it get next to current

  const renderPageButtons = () => {
    const pageButtons = [];
    let pageItems = 8;
    let pageLastItem = 0;
    if (pageItems < pageCount - 2) {
      const pageRow = Math.ceil(page / pageItems);
      pageLastItem = pageRow * pageItems; // - (pageRow === 1 ? 0 : 1);
      if (pageLastItem > pageCount) {
        pageItems = pageLastItem - pageCount;
        pageLastItem = pageCount;
      }
      //   console.log("PageRow", pageRow, pageLastItem, pageCount);
    } else {
      pageLastItem = pageCount;
      pageItems = pageCount;
    }

    // print prev button pages
    for (let i = 0, itemNum = pageLastItem; i < pageItems; i += 1) {
      //   console.log("Page Item ", itemNum);
      pageButtons.push(itemNum);
      itemNum -= 1;
    }
    pageButtons.reverse();

    if (pageButtons[0] > 1) {
      pageButtons.splice(0, 1, pageButtons[0] - 1, pageButtons[0]);
    }

    if (pageCount - pageLastItem > 2) {
      // print next to last with dot else number itself
      pageButtons.push('...');
      pageButtons.push(pageCount);
    } else {
      // print next two items
      for (let i = pageLastItem + 1; i <= pageCount; i += 1) {
        pageButtons.push(i);
      }
    }

    return pageButtons.map((item, index) => (
      <PageButton
        key={item}
        className={item === page ? 'active' : ''}
        onClick={() => {
          const pageNum = item === '...' ? pageButtons[index - 1] + 1 : item;
          gotoPage(pageNum - 1);
        }}
      >
        {item}
      </PageButton>
    ));
  };

  return (
    <PaginationWrapper>
      <div>{renderPageButtons()}</div>
      <div className="page-size" style={{minWidth: '170px'}}>
        <StyledSelect2Bordered
          classNamePrefix="react-select"
          options={pageSizes}
          defaultValue={
            pageSizes.find((item) => item.value === pageSize) || pageSizes[0]
          }
          menuPlacement="auto"
          menuPortalTarget={document.body}
          onChange={(val) => {
            setPageSize(Number(val.value));
          }}
          styles={{
            menu: (provided) => ({
              ...provided,
              backgroundColor: '#EDEDED',
              borderColor: '#DFDFDF',
            }),
            option: (styles) => {
              return {
                ...styles,

                ':hover': {
                  ...styles[':hover'],
                  color: '#000',
                  fontWeight: 600,
                  backgroundColor: '#DFDFDF',
                },
              };
            },
          }}
        />
      </div>
    </PaginationWrapper>
  );
};

export default Pagination;
